import React from 'react';
import { Link } from 'react-router-dom';
import { COMPANY_INFO, SERVICE_LINKS, LEGAL_LINKS } from '../../constants/company';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-brand-secondary text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center">
                <img src="/OnsLogo.png" alt="ONS METTLE" className="w-8 h-8 object-contain" />
              </div>
              <div>
                <h3 className="text-xl font-bold font-heading">{COMPANY_INFO.name}</h3>
                <p className="text-sm text-white/70">{COMPANY_INFO.tagline}</p>
              </div>
            </div>
            <p className="text-white/90 font-body mb-6 max-w-md leading-relaxed">
              {COMPANY_INFO.description}
            </p>
            <div className="flex space-x-4">
              {COMPANY_INFO.social.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors"
                  aria-label={social.name}
                >
                  <span className="text-white text-sm font-semibold">{social.shortName}</span>
                </a>
              ))}
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold font-heading mb-4">Services</h4>
            <ul className="space-y-2 font-body">
              {SERVICE_LINKS.map((link) => (
                <li key={link.name}>
                  <Link to={link.href} className="footer-link-hover">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          
          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold font-heading mb-4">Contact</h4>
            <ul className="space-y-2 text-white/80 font-body">
              <li>{COMPANY_INFO.contact.email}</li>
              <li>{COMPANY_INFO.contact.phone}</li>
              {COMPANY_INFO.contact.locations.map((location, index) => (
                <li key={index}>{location}</li>
              ))}
            </ul>
          </div>
        </div>
        
        <div className="border-t border-white/20 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-white/60 text-sm font-body">
            © {currentYear} Ons Mettle Corporate. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            {LEGAL_LINKS.map((link) => (
              <a key={link.name} href={link.href} className="footer-link-hover text-sm">
                {link.name}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;